import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

// Status → display label + colour mapping (matches Uber Eats / DoorDash conventions)
const STATUS_CONFIG = {
    delivered:        { label: "Delivered",       color: "rgba(39, 196, 83, 1)" },
    out_for_delivery: { label: "On Delivery",     color: "rgba(245, 126, 42, 1)" },
    cancelled:        { label: "Cancelled",       color: "rgba(226, 29, 37, 1)" },
    preparing:        { label: "Preparing",       color: "rgba(94, 64, 153, 1)" },
    ready_for_pickup: { label: "Ready",           color: "rgba(44, 185, 255, 1)" },
    accepted:         { label: "Accepted",        color: "rgba(49, 49, 49, 1)" },
    new_order:        { label: "New",             color: "rgba(143, 143, 143, 1)" },
};

/**
 * PieChart — Order status distribution
 * Props:
 *   data: Array<{ status, count, percentage }> — from API orderDistribution field
 */
const PieChart = ({ data = [] }) => {
    // Filter out statuses with 0 orders so the pie isn't polluted
    const filteredData = data.filter(d => d.count > 0);

    const seriesData = filteredData.map(d => ({
        name: STATUS_CONFIG[d.status]?.label || d.status,
        y: d.percentage,
        color: STATUS_CONFIG[d.status]?.color || "rgba(143,143,143,1)",
        count: d.count,
    }));

    // Fallback placeholder data when no real data available
    const placeholderData = [
        { name: "No Data", y: 100, color: "rgba(236,236,236,1)", count: 0 },
    ];

    const options = {
        chart: {
            type: "pie",
            backgroundColor: "transparent",
            style: { fontFamily: "inherit" },
        },
        title: { text: "" },
        tooltip: {
            formatter: function () {
                return `<b>${this.point.name}</b><br/>
                    Orders: <b>${this.point.count}</b><br/>
                    Share: <b>${this.point.percentage.toFixed(1)}%</b>`;
            },
        },
        accessibility: { point: { valueSuffix: "%" } },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor: "pointer",
                dataLabels: { enabled: false },
                showInLegend: true,
                borderWidth: 0,
                innerSize: "40%", // Donut style (modern look)
            },
        },
        legend: {
            align: "center",
            verticalAlign: "bottom",
            layout: "horizontal",
            itemMarginTop: 8,
            itemStyle: { color: "#333", fontWeight: "normal", fontSize: "12px" },
        },
        series: [
            {
                name: "Orders",
                colorByPoint: true,
                data: seriesData.length ? seriesData : placeholderData,
            },
        ],
        credits: { enabled: false },
    };

    return (
        <div className="chart">
            <HighchartsReact highcharts={Highcharts} options={options} />
        </div>
    );
};

export default PieChart;
